/***
 * @file: å¬ç¨æ¹æ³
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */

import { cloneDeep, findIndex, includes, intersection, pull, trim } from 'lodash';
import { isEmpty as lodashIsEmpty } from 'lodash';
import { isEqual as lodashIsEqual } from 'lodash';

/**
 * å é¤å¯¹è±¡ä¸­çç©ºå¼
 * @param obj è¦å é¤ç©ºå¼çå¯¹è±¡
 * @example
 * ```
 * {a: 1, b: ''} ==> {a: 1}
 * ```
 */

export function deleteEmptyObj(obj: object): object {
  const newObj = trimFormValue(cloneDeep(obj));
  for (const key in newObj) {
    if (isEmpty(newObj[key]) && !newObj[key]) {
      delete newObj[key];
    }
  }
  return newObj;
}

/**
 * å»é¤è¡¨åå¼å¾ååç©ºæ ¼
 * @param obj è¡¨åå¯¹è±¡
 */
export function trimFormValue(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'number' || typeof obj[key] === 'string') {
      obj[key] = trim(obj[key]);
    }
  }
  return obj;
}

/**
 * å¯¹è±¡ä¸­è¥ææ¥ææ ¼å¼çï¼åèªå¨è½¬æ¢ä¸ºæ¶é´æ³
 * @param obj è¦è½¬æ¢çå¯¹è±¡
 */

export function dateToTimestamp(obj: object) {
  const newObj = cloneDeep(obj);
  for (const key in newObj) {
    if (newObj[key] instanceof Date) {
      newObj[key] = newObj[key].getTime();
    }
  }

  return newObj;
}

// æ¯å¦ä¸ºç©º
export function isEmpty(val: any): boolean {
  return lodashIsEmpty(val);
}

/**
 * æ çå±æ§è½¬æ¢
 * @param tree æ ç»æçæ°æ®
 * å åç«¯ä¼ éçæ å­æ®µåUIæ¡æ¶ä¸ä¸è´ï¼æéç»ä¸è½¬æ¢
 *   UIåºåç§°       åç«¯ç»çå­æ®µåç§°    éä¹
 *   title          label             æ èç¹çåç§°
 *   key            id                æ èç¹å¯ä¸æ å¿
 */
export function formatTree(tree = []): any[] {
  tree.forEach((data) => {
    data.title = data.label;
    data.key = data.id;
    delete data.label;
    delete data.id;
    if (data.children && !isEmpty(data.children)) {
      formatTree(data.children);
    } else {
      data.isLeaf = true;
    }
  });
  return tree;
}

export function getCheckedData(data: any[]) {
  const checkedArr = [];
  data.forEach((item) => {
    if (item.checked) {
      checkedArr.push(item);
    }
  });
  return checkedArr;
}

/****
 * å¤æ­ä¸ä¸ªåç´ å¨æ°ç»ä¸­æ¯å¦å­å¨
 */
export function isExist(arr: any, str: string): boolean {
  const idx = arr.indexOf(str);
  return idx > -1 ? true : false;
}

/**
 * æ°ç»å»é
 */
export function setUniq(arr): any[] {
  return Array.from(new Set(arr));
}

/**
 * æ§è¡æ·±æ¯è¾æ¥å³å®ä¸¤èçå¼æ¯å¦ç¸ç­ã
 * æ³¨æ: è¿ä¸ªæ¹æ³æ¯ææ¯è¾ arrays, array buffers, booleans, date objects, error objects,
 * maps, numbers, Object objects, regexes, sets, strings, symbols, ä»¥å typed arrays. Object
 *  å¯¹è±¡å¼æ¯è¾èªèº«çå±æ§ï¼ä¸åæ¬ç»§æ¿çåå¯æä¸¾çå±æ§ã ä¸æ¯æå½æ°åDOMèç¹ã
 */
export function isEqual(temp1, temp2): any[] {
  return lodashIsEqual(temp1, temp2);
}

/**
 * å¤æ­ä¸¤ä¸ªæ°ç»æ¯å¦æäº¤é
 * _.intersection([arrays]): å¦ææç¸åçåè¿åç¸åçï¼æ²¡æåè¿åâ[]âï¼ç©ºæ°ç»ï¼
 */
export function hasIntersection(arr1, arr2): boolean {
  const ins = intersection(arr1, arr2);
  return isEmpty(ins) ? false : true;
}

/**
 * æ¥è¯¢æ°ç»ä¸­åç´ çä½ç½®ï¼è¯¥åç´ å¯ä¸ºå¼ç¨ç±»å
 */
export function getIndex(arr, val): number {
  return findIndex(arr, val);
}

/**
 * å¤æ­æ°ç»ä¸­æ¯å¦åå«æåç´ ï¼è¯¥åç´ å¯ä¸ºå¼ç¨ç±»å
 */
export function isHas(arr, val): boolean {
  const idx = getIndex(arr, val);
  return idx > -1 ? true : false;
}

/**
 * æ°ç»å»éï¼å¯é¤å»å¼ç¨ç±»åæ°æ®
 */
export function arrUniq(arr) {
  if (isEmpty(arr)) {
    return [];
  }
  const newArr = [];
  arr.forEach((ele) => {
    if (isHas(newArr, ele)) {
      return;
    }
    newArr.push(ele);
  });

  return newArr;
}

// æ°ç»ä¸­å¯¹è±¡å»é, æ ¹æ®keyè¿è¡å¹éå é¤
export function arrayUniqueObj(arr, key) {
  const hash = {};
  return arr.reduce((item, next) => {
    if (!hash[next[key]]) {
      hash[next[key]] = true && item.push(next);
    }
    return item;
  }, []);
}

/***
 * @desc æ°ç»ä¸­å é¤æå®åç´ ï¼å¯ä¸ºå¼ç¨ç±»å
 *
 * @param arr è¦å é¤çæ°æ®
 * @param item è¦å é¤çåç´  å¯ä»¥æ¯å¼ç±»ååå¼ç¨ç±»å
 * @param key æ ¹æ®æ­¤keyçvalueç¸ååå é¤ï¼å¯éä¼ å¥ï¼é»è®¤ä¸ä¾æ®
 * @param options æ¯å¦æ¹ååæ°ç»ï¼é»è®¤æ¹ååæ°ç»ã true ä¸æ¹ååæ°ç»ï¼å¹¶è¿åå¤çåçæ°ç»ï¼ falseæ¹ååæ°ç»å¹¶è¿ååæ¹ååçå¼
 *
 * @example
 *   key
 *   ```
 *   let a = [{key1: 1, key3: 3},{key2: 2}];
 *   let b = {key1: 1}
 *
 *   1. ä¼ key
 *      let f =  array_deleteItem(a, b, 'key3');  // a ==> [{key2: 2}]; f ==>  [{key2: 2}]
 *   2. ä¸ä¼ key
 *      let f =  array_deleteItem(a, b, null);  // a ==>  [{key1: 1},{key2: 2}]; f ==>  [{key1: 1},{key2: 2}];
 *   ```
 *   option
 *   ```
 *   let a = [{key1: 1},{key2: 2}];
 *   let b = {key1: 1}
 *
 *   1. ä¸ä¼ option,ä¼æ¹ååæ°ç»ï¼å¹¶è¿åä¿®æ¹åçæ°ç»
 *      let f =  array_deleteItem(a, b);  // a ==> [{key2: 2}]; f ==>  [{key2: 2}]
 *   2. optionéç½®ä¸ºtureï¼ä¸ä¼æ¹ååæ°ç»ï¼å¹¶è¿åä¿®æ¹åçæ°ç»
 *      let f =  array_deleteItem(a, b, null, true);  // a ==> [{key1: 1},{key2: 2}]; f ==> [{key2: 2}]
 *   ```
 */
export function array_deleteItem(arr: any[], item: any, key?: string, option?: boolean) {
  arr = option ? cloneDeep(arr) : arr;
  if (key) {
    arr.forEach((ele, idx) => {
      if (isEqual(ele[key], item[key])) {
        arr.splice(idx, 1);
      }
    });
  } else {
    arr.forEach((ele, idx) => {
      if (isEqual(ele, item)) {
        arr.splice(idx, 1);
      }
    });
  }

  return arr;
}

export function dtPull(arr, data) {
  return pull(arr, data);
}

/**
 * å¤æ­ä¸ä¸ªæ°ç»æ¯å¦åå«å¦å¤ä¸ä¸ªæ°ç»
 * @example
 * ```
 * import { isContained } from "@shared/utils/check.ts";
 * ...
 *
 * let a = [1,2,3,4],
 *     b = [1,2];
 * isContained(a, b);  //true
 *
 * ```
 * @param a ç¶æ°ç»
 * @param b å­æ°ç»
 * @desc aéé¢æ¯å¦æb
 */

export function isContained(parentArr: string[], sonArr: string[]): boolean {
  if (parentArr instanceof Array) {
    for (let i = sonArr.length - 1; i >= 0; i--) {
      if (!includes(parentArr, sonArr[i])) {
        return false;
      }
    }
    return true;
  }
}

/***
 * @desc åå­è¿å¶é¢è²ç è½¬ä¸ºrgbaæ ¼å¼
 * @param color åå­è¿å¶é¢è²
 * */
export function colorRgb(color: string, fade: string | number = 1) {
  if (!color) {
    return;
  }
  // åå­è¿å¶é¢è²å¼çæ­£åè¡¨è¾¾å¼
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  color = color.toLowerCase();
  // å¦ææ¯16è¿å¶é¢è²
  if (reg.test(color)) {
    if (color.length === 4) {
      let colorNew = '#';
      for (let i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
    }
    // å¤çå­ä½çé¢è²å¼
    const colorChange = [];
    for (let i = 1; i < 7; i += 2) {
      // tslint:disable-next-line:radix
      colorChange.push(parseInt('0x' + color.slice(i, i + 2)));
    }
    return `rgba(${colorChange.join(',')}, ${fade})`;
  }
  return color;
}

/**
 * @description æ·±åº¦åå¹¶
 * @params åå¹¶çåæ°
 */
export const deepMerge = (...objArr) => {
  const ret = {}; // åå§åçç©ºå¯¹è±¡
  function handler(key, source, rets) {
    const isObj = Object.prototype.toString.call(source[key]) === '[object Object]';
    if (isObj) {
      if (!rets[key]) {
        rets[key] = {}; // é®åä¸å­å¨ï¼æ·è´é®å
      }
      // ç±äºæ¯å¯¹è±¡éè¦ç¨éå½å®ç°æ·±åº¦çcopy
      Object.keys(source[key]).forEach((_key) => {
        handler(_key, source[key], rets[key]);
      });
    } else {
      // æ¯éå¼ç¨ç±»åãç´æ¥æ·è´é®åæå¯¹åºçå¼
      rets[key] = source[key];
    }
  }

  objArr.forEach((item) => {
    Object.keys(item).forEach((key) => {
      handler(key, item, ret);
    });
  });
  return ret;
};

export const randomId = () => {
  return (
    (Math.random() * 10000000).toString(16).substr(0, 4) +
    +new Date().getTime() +
    +Math.random()
      .toString()
      .substr(2, 5)
  );
};

export function getOs() {
  let OS = '';
  const OSArray: any = {};
  const UserAgent = navigator.userAgent.toLowerCase();
  OSArray.Windows = navigator.platform === 'Win32' || navigator.platform === 'Windows';
  OSArray.Mac =
    navigator.platform === 'Mac68K' ||
    navigator.platform === 'MacPPC' ||
    navigator.platform === 'Macintosh' ||
    navigator.platform === 'MacIntel';
  OSArray.iphone = UserAgent.indexOf('iPhone') > -1;
  OSArray.ipod = UserAgent.indexOf('iPod') > -1;
  OSArray.ipad = UserAgent.indexOf('iPad') > -1;
  OSArray.Android = UserAgent.indexOf('Android') > -1;
  for (const i in OSArray) {
    if (OSArray[i]) {
      OS = i;
    }
  }
  return OS;
}
